/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Component spacing variables */
  --calcite-icon-size: 1rem;
  --calcite-spacing-eighth: 0.125rem;
  --calcite-spacing-quarter: 0.25rem;
  --calcite-spacing-half: 0.5rem;
  --calcite-spacing-three-quarters: 0.75rem;
  --calcite-spacing: 1rem;
  --calcite-spacing-plus-quarter: 1.25rem;
  --calcite-spacing-plus-half: 1.5rem;
  --calcite-spacing-double: 2rem;
  --calcite-menu-min-width: 10rem;
  --calcite-header-min-height: 3rem;
  --calcite-footer-min-height: 3rem;
}

:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-select-font-size: The font size of `calcite-option`s in the component.
* @prop --calcite-select-spacing: The padding around the selected option text.
*/
:host {
  display: flex;
  flex-direction: column;
}

.wrapper {
  position: relative;
  display: flex;
  align-items: stretch;
  inline-size: var(--select-width);
}
.wrapper:focus-within .icon, .wrapper:active .icon, .wrapper:hover .icon {
  color: var(--calcite-color-text-1);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([scale=s]) {
  --calcite-select-font-size: var(--calcite-font-size--2);
  --calcite-select-spacing-inline: 0.5rem 2rem;
}
:host([scale=s]) .wrapper {
  block-size: 1.5rem;
}
:host([scale=s]) .icon-container {
  padding-inline: 0.5rem;
}

:host([scale=m]) {
  --calcite-select-font-size: var(--calcite-font-size--1);
  --calcite-select-spacing-inline: 0.75rem 2.5rem;
}
:host([scale=m]) .wrapper {
  block-size: 2rem;
}
:host([scale=m]) .icon-container {
  padding-inline: 0.75rem;
}

:host([scale=l]) {
  --calcite-select-font-size: var(--calcite-font-size-0);
  --calcite-select-spacing-inline: 1rem 3rem;
}
:host([scale=l]) .wrapper {
  block-size: 44px;
}
:host([scale=l]) .icon-container {
  padding-inline: 1rem;
}

:host([width=auto]) {
  inline-size: auto;
}

:host([width=half]) {
  inline-size: 50%;
}

:host([width=full]) {
  inline-size: 100%;
}

.select {
  margin: 0px;
  box-sizing: border-box;
  inline-size: 100%;
  cursor: pointer;
  appearance: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 0px;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-foreground-1);
  font-family: inherit;
  color: var(--calcite-color-text-2);
  outline-color: transparent;
  font-size: var(--calcite-select-font-size);
  padding-inline: var(--calcite-select-spacing-inline);
  border-inline-end-width: 0px;
}
.select:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

select:disabled {
  border-color: var(--calcite-color-border-input);
  --tw-bg-opacity: 1;
}

.icon-container {
  pointer-events: none;
  position: absolute;
  inset-block: 0px;
  display: flex;
  align-items: center;
  border-width: 0px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: transparent;
  color: var(--calcite-color-text-2);
  inset-inline-end: 0px;
  border-inline-width: 0px 1px;
}
.icon-container .icon {
  color: var(--calcite-color-text-3);
}

:host([status=invalid]) select,
:host([status=invalid]) .icon-container {
  border-color: var(--calcite-color-status-danger);
}
:host([status=invalid]) select:focus,
:host([status=invalid]) .icon-container:focus {
  outline: 2px solid var(--calcite-color-status-danger);
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.select:focus ~ .icon-container {
  border-color: transparent;
}

.validation-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

:host([scale=m]) .validation-container,
:host([scale=l]) .validation-container {
  padding-block-start: 0.5rem;
}

:host([scale=s]) .validation-container {
  padding-block-start: 0.25rem;
}

::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}